/**
 * Topology Store
 *
 * @since 2018-11-19
 * @author mk.ko
 */
export const state = () => ({
  topologyData: {},
  updateTime: '',
  refreshAll: 0
})

export const mutations = {
  initTopologyStore (state) {
    state.topologyData = Object.freeze({})
    state.updateTime = ''
    state.refreshAll = 0
  },
  setTopologyData (state, topologyData) {
    // 0: 장비 그룹, 1: Stand-Alone 장비, 2: Master 장비, 3: Slave 장비, 4: TAMS Group, 5: TAMS Master, 6: TAMS Slave
    // DEVICE_ID : Root: 1, TAMS 그룹 : 2, TAMS-Master : 3 (항상 고정)

    // TAMS 모니터링 권한 여부 체크
    // const isExistTams = Boolean(topologyData.nodes.some(node => node.id === '3'))
    //
    // // source: 부모 (상단)
    // // target: 자식 (하단)
    //
    // if (isExistTams) {
    //   // Root 노드, TAMS 그룹 제거
    //   topologyData.nodes = topologyData.nodes.filter(node => node.id !== '1' && node.id !== '2')
    //
    //   // Root - TAMS 그룹 링크, TAMS 그룹 - TAMS Master 링크 제거
    //   topologyData.links = topologyData.links.filter(link => {
    //     // TAMS 노드 보정 (기존 Root 링크 TAMS로 변경)
    //     if (link.source === '1' || link.source === '2') {
    //       link.source = '3'
    //     }
    //     return link.target !== '2' && link.target !== '3'
    //   })
    // } else {
    //   // TAMS 그룹 제거
    //   topologyData.nodes = topologyData.nodes.filter(node => node.id !== '2')
    //   // TAMS 그룹과 연결된 링크 제거 (전제, forceGraph 랜더링 전, target, source 값이 문자열 아이디일 경우에만 동작)
    //   // 랜더링 이후는 해당 노드 정보로 변경됨
    //   topologyData.links = topologyData.links.filter(link => link.target !== '2')
    // }

    state.topologyData = Object.freeze({
      nodes: topologyData.nodes,
      links: topologyData.links
    })
    state.updateTime = topologyData.update_time
    state.refreshAll = topologyData.refresh_all
  }
}
export const actions = {
  async getTopologyData ({ state, commit }, force) {
    // Axios 호출
    const apiUrl = state.updateTime.length === 0 || force ? `/api/da/topology/data/None` : `/api/da/topology/data/${state.updateTime}`
    const res = await this.$axios.$get(apiUrl, {
      loading: false,
      successAlert: false
    })

    // 호출된 데이터 확인
    if (res.code === 'ok') {
      commit('setTopologyData', res.result)
    }

    return res
  }
}

export const getters = {}
export const strict = false
